// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Signal } from '@lumino/signaling';
import { EditorHandler } from '../handlers/editor';
import { nullTranslator } from '@jupyterlab/translation';
import { DebuggerPausedOverlay } from './pausedoverlay';
/**
 * A handler for files.
 */
export class FileHandler {
    /**
     * Instantiate a new FileHandler.
     *
     * @param options The instantiation options for a FileHandler.
     */
    constructor(options) {
        var _a, _b;
        this._debuggerService = options.debuggerService;
        this._fileEditor = options.widget.content;
        this.translator = options.translator || nullTranslator;
        this._hasLineNumber =
            (_a = this._fileEditor.editor.getOption('lineNumbers')) !== null && _a !== void 0 ? _a : false;
        this._editorHandler = new EditorHandler({
            debuggerService: this._debuggerService,
            editorReady: () => Promise.resolve(this._fileEditor.editor),
            getEditor: () => this._fileEditor.editor,
            src: this._fileEditor.model.sharedModel
        });
        this._pausedOverlay = new DebuggerPausedOverlay({
            debuggerService: this._debuggerService,
            container: options.widget.node,
            translator: this.translator
        });
        (_b = this._debuggerService.session) === null || _b === void 0 ? void 0 : _b.eventMessage.connect((_, event) => {
            var _a, _b, _c;
            const session = this._debuggerService.session;
            const contextSession = options.widget.context.sessionContext.session;
            if (!session || !contextSession) {
                return;
            }
            if (((_b = (_a = session.connection) === null || _a === void 0 ? void 0 : _a.kernel) === null || _b === void 0 ? void 0 : _b.id) !== ((_c = contextSession.kernel) === null || _c === void 0 ? void 0 : _c.id)) {
                return;
            }
            if (event.event === 'stopped') {
                void this._pausedOverlay.show();
            }
            else if (event.event === 'continued' || event.event === 'terminated') {
                void this._pausedOverlay.hide();
            }
        });
        if (this._debuggerService.hasStoppedThreads()) {
            void this._pausedOverlay.show();
        }
    }
    /**
     * Dispose the handler.
     */
    dispose() {
        var _a, _b;
        if (this.isDisposed) {
            return;
        }
        this.isDisposed = true;
        this._pausedOverlay.dispose();
        (_a = this._editorHandler) === null || _a === void 0 ? void 0 : _a.dispose();
        // Restore editor options
        (_b = this._editorHandler) === null || _b === void 0 ? void 0 : _b.editor.setOptions({
            lineNumbers: this._hasLineNumber
        });
        Signal.clearData(this);
    }
}
//# sourceMappingURL=file.js.map